
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <div class="page-wrapper" *ngIf="userService.business">

    <div class="name-img-wrapper">
      <div class="name">{{userService.business.name}}</div>
    </div>

    <div class="middle-info">

      <div class="section-header">Select your location</div>

      <ion-item class="input-item" lines="none">
        <ion-select [(ngModel)]="selectedBusinessLocationID" (ionChange)="selectNewLocation()" value="" placeholder="Choose location" [interfaceOptions]="interfaceOptions('Location', 'Add new locations in Business Settings.')">
          <ion-select-option *ngFor="let l of businessLocations" value="{{l.id}}">
            {{l.name}}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <span *ngIf="selectedBusinessLocationID">
        <p class="stripe-id">Stripe ID: {{stripeIDForSelectedBusiness()}}</p>
        <p class="stripe-id" *ngIf="hasMultipleLocationsWithStripeAccount()">Note: You have multiple Locations set to this Stripe account. This page will display all transfers/payouts for this Stripe account.</p>
        <p class="view-stripe-button" (click)="openStripe()">View Stripe account</p>
      </span>

      <br>
      <hr>

      <div class="section-header">Transfers to this Stripe account</div>

      <ion-item class="item-with-subtext" lines="none">
        <ion-label>
          Appointments, Invoices and Tips are sent to Stripe
          <p>within 24 hours of payment received.</p>
        </ion-label>
      </ion-item>

      <ion-list class="payment-list">
        <ion-item *ngFor="let p of transfers">
          <ion-label>
            {{ p.paid ? 'Sent to Stripe' : 'Pending' }}: {{formatCost(p.amount, p.currency)}}
            <p>Transferred on {{monthDate(p.createdAt)}}</p>
            <p>{{p.proName}} for {{p.name}} | {{monthDate(p.apptDate)}}</p>
            <p>{{p.type}}</p>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="!transfers">
          <ion-label>
            Loading...
          </ion-label>
        </ion-item>
        <ion-item *ngIf="transfers && !transfers.length">
          <ion-label>
            No recent transfers for this location.
          </ion-label>
        </ion-item>
      </ion-list>

      <div class="export-button" (click)="downloadTransfers()" *ngIf="transfers && transfers.length">
        <ion-icon name="download-outline"></ion-icon>
        Export recent transfers
      </div>

      <br>
      <hr>

      <div class="section-header">Stripe payout history</div>

      <ion-item class="item-with-subtext" lines="none">
        <ion-label>
          Stripe pays out the available balance automatically
          <p>to your bank on file, on a daily rolling basis. </p>
        </ion-label>
      </ion-item>

      <ion-list class="payment-list">
        <ion-item *ngFor="let p of payouts">
          <ion-label>
            {{formatCost(p.amountUSD, p.currency)}}
            <p>Type: {{p.description}}</p>
            <p>Status: {{p.status}}</p>
            <p>Sent by Stripe: {{monthDate(p.created)}}</p>
            <p>Estimated arrival: {{monthDate(p.estArrivalDate)}}</p>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="!payouts">
          <ion-label>
            Loading...
          </ion-label>
        </ion-item>
        <ion-item *ngIf="payouts && !payouts.length">
          <ion-label>
            No recent payouts for this location.
          </ion-label>
        </ion-item>
      </ion-list>

      <div class="export-button" (click)="downloadPayouts()" *ngIf="payouts && payouts.length">
        <ion-icon name="download-outline"></ion-icon>
        Export recent payouts
      </div>

    </div>

    <br><br>
  </div>

</ion-content>

<ion-footer slot="fixed" class="SC-support-footer">
  <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
  <span class="support-button" (click)="adminChat()">Live chat</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
</ion-footer>